import React from 'react';

// Global "Developed by" credit pinned to the bottom-right of every page.
// Kept subtle so it doesn't compete with primary CTAs; non-interactive.
export const DeveloperCredit = () => (
  <div
    data-testid="developer-credit"
    aria-hidden="false"
    style={{
      position: 'fixed',
      bottom: '10px',
      right: '14px',
      zIndex: 40,
      fontSize: '11px',
      fontFamily: 'Work Sans, -apple-system, BlinkMacSystemFont, sans-serif',
      letterSpacing: '0.02em',
      color: '#57534E',
      background: 'rgba(247, 247, 245, 0.85)',
      backdropFilter: 'blur(6px)',
      WebkitBackdropFilter: 'blur(6px)',
      padding: '4px 10px',
      borderRadius: '999px',
      border: '1px solid rgba(27, 67, 50, 0.08)',
      pointerEvents: 'none',
      userSelect: 'none',
    }}
  >
    Developed by: <span style={{ color: '#1B4332', fontWeight: 500 }}>Harshesh Shah</span>
  </div>
);

export default DeveloperCredit;
